// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1C5KQ","selects":"Documents_selects__203nH"};